module.exports = __webpack_public_path__ + "img/gift2-02-c1.851b7386.png";